/* tslint:disable */
/* eslint-disable */
export enum OccupationType {
  Unspecified = 'Unspecified',
  ArtsandMediaProfessionals = 'ArtsandMediaProfessionals',
  AutomotiveAndEngineeringTradesWorkers = 'AutomotiveAndEngineeringTradesWorkers',
  BusinessHumanResourceAndMarketingProfessionals = 'BusinessHumanResourceAndMarketingProfessionals',
  CarersandAides = 'CarersandAides',
  ChiefExecutivesGeneralManagersandLegislators = 'ChiefExecutivesGeneralManagersandLegislators',
  CleanersandLaundryWorkers = 'CleanersandLaundryWorkers',
  ClericalandOfficeSupportWorkers = 'ClericalandOfficeSupportWorkers',
  ConstructionandMiningLabourers = 'ConstructionandMiningLabourers',
  ConstructionTradesWorkers = 'ConstructionTradesWorkers',
  DesignEngineeringScienceandTransportProfessionals = 'DesignEngineeringScienceandTransportProfessionals',
  EducationProfessionals = 'EducationProfessionals',
  ElectroTechnologyAndTelecommunicationsTradesWorkers = 'ElectroTechnologyAndTelecommunicationsTradesWorkers',
  EngineeringIctAndScienceTechnicians = 'EngineeringIctAndScienceTechnicians',
  FactoryProcessWorkers = 'FactoryProcessWorkers',
  FarmForestryAndGardenWorkers = 'FarmForestryAndGardenWorkers',
  FarmersandFarmManagers = 'FarmersandFarmManagers',
  FoodPreparationAssistants = 'FoodPreparationAssistants',
  FoodTradesWorkers = 'FoodTradesWorkers',
  GeneralClericalWorkers = 'GeneralClericalWorkers',
  HealthAndWelfareSupportWorkers = 'HealthAndWelfareSupportWorkers',
  HealthProfessionals = 'HealthProfessionals',
  HospitalityWorkers = 'HospitalityWorkers',
  HospitalityRetailandServiceManagers = 'HospitalityRetailandServiceManagers',
  HousewifeHusband = 'HousewifeHusband',
  IctProfessionals = 'ICTProfessionals',
  InquiryClerksandReceptionists = 'InquiryClerksandReceptionists',
  Invalidpensioner = 'Invalidpensioner',
  LegalSocialandWelfareProfessionals = 'LegalSocialandWelfareProfessionals',
  MachineandStationaryPlantOperators = 'MachineandStationaryPlantOperators',
  MobilePlantOperators = 'MobilePlantOperators',
  NumericalClerks = 'NumericalClerks',
  OfficeManagersAndProgramAdministrators = 'OfficeManagersAndProgramAdministrators',
  OtherClericalandAdministrativeWorkers = 'OtherClericalandAdministrativeWorkers',
  OtherLabourers = 'OtherLabourers',
  OtherOccupationInadequatelyDescribed = 'OtherOccupationInadequatelyDescribed',
  OtherPensioner = 'OtherPensioner',
  OtherTechniciansAndTradesWorkers = 'OtherTechniciansAndTradesWorkers',
  PersonalAssistantsAndSecretaries = 'PersonalAssistantsAndSecretaries',
  ProtectiveServiceWorkers = 'ProtectiveServiceWorkers',
  RoadandRailDrivers = 'RoadandRailDrivers',
  SalesAssistantsAndSalespersons = 'SalesAssistantsAndSalespersons',
  SalesRepresentativesAndAgents = 'SalesRepresentativesAndAgents',
  SalesSupportWorkers = 'SalesSupportWorkers',
  SkilledAnimalAndHorticulturalWorkers = 'SkilledAnimalAndHorticulturalWorkers',
  SpecialistManagers = 'SpecialistManagers',
  SportsandPersonalServiceWorkers = 'SportsandPersonalServiceWorkers',
  StorePersons = 'StorePersons',
  BusinessFinanceandMarketingProfessionals = 'BusinessFinanceandMarketingProfessionals',
  ArtsandMediaAndSportsProfessionals = 'ArtsandMediaAndSportsProfessionals',
  EngineeringIctAndTechnicalProfessionals = 'EngineeringIctAndTechnicalProfessionals',
  ScienceAndResearchProfessionals = 'ScienceAndResearchProfessionals',
  PublicSectorGovernmentRoles = 'PublicSectorGovernmentRoles',
  ConstructionAndMiningWorkers = 'ConstructionAndMiningWorkers',
  AgricultureHorticultureAndAnimalWorkers = 'AgricultureHorticultureAndAnimalWorkers',
  CleaningAndMaintenanceWorkers = 'CleaningAndMaintenanceWorkers',
  ClericalAndAdministrativeWorkers = 'ClericalAndAdministrativeWorkers',
  AutomotiveAndElectrotechnologyTradesWorkers = 'AutomotiveAndElectrotechnologyTradesWorkers',
  HospitalityAndFoodServicesWorkers = 'HospitalityAndFoodServicesWorkers',
  RealEstateAndPropertyServices = 'RealEstateAndPropertyServices',
  TransportAndLogisticsWorkers = 'TransportAndLogisticsWorkers',
  ManufacturingAndProductionWorkers = 'ManufacturingAndProductionWorkers',
  SecurityAndProtectiveServices = 'SecurityAndProtectiveServices',
  EmergencyServices = 'EmergencyServices',
  ManagersAndExecutives = 'ManagersAndExecutives',
  RetailAndSalesWorkers = 'RetailAndSalesWorkers'
}
